import { render, staticRenderFns } from "./ScoreTableRadarChart.vue?vue&type=template&id=e5cda3f2"
import script from "./ScoreTableRadarChart.vue?vue&type=script&lang=js"
export * from "./ScoreTableRadarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports